// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PForwardOutlinedSvg from "@fishx/icons-svg/es/asn/PForwardOutlined";
import FishxIcon from '../components/FishxIcon';

var PForwardOutlined = function PForwardOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PForwardOutlinedSvg
  }));
};

PForwardOutlined.displayName = 'PForwardOutlined';
export default React.forwardRef(PForwardOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PForwardOutlined.js
// module id = 3425
// module chunks = 0